import type { CoreDispatch } from '../../store/CoreStore';

export enum PopupType {
  AutoplayModified = 'AutoplayModified',
  AutoplayStopped = 'AutoplayStopped',
  ConnectionLost = 'ConnectionLost',
  CustomPopup = 'CustomPopup',
  DontLeaveRoundInProgress = 'DontLeaveRoundInProgress',
  ExitConfirmation = 'ExitConfirmation',
  GenericError = 'GenericError',
  GenericErrorNoRefresh = 'GenericErrorNoRefresh',
  SessionExpired = 'SessionExpired',
  Inactivity = 'Inactivity',
  LoggedOut = 'LoggedOut',
  NicknameEnter = 'NicknameEnter',
  RealityCheck = 'RealityCheck',
  Reconnecting = 'Reconnecting',
  SessionBalance = 'SessionBalance',
  TableClosed = 'TableClosed',
  PrivateTableOccupied = 'PrivateTableOccupied',
  VipTableLowBalance = 'VipTableLowBalance',
  SessionBalanceError = 'SessionBalanceError',
  Error = 'Error',
  ByInvitation = 'ByInvitation',
  DuplicatePrivatePlayerSession = 'DuplicatPrivatePlayerSession',
  BeforeInactivity = 'BeforeInactivity',
  HighlightPopup = 'HighlightPopup',
  SessionTerminated = 'SessionTerminated',
  AuthError = 'AuthError',
}

export enum PopupVariant {
  Skeleton = 'Skeleton',
}

export enum loadingStatus {
  loading = 'Loading',
  success = 'Success',
  failed = 'Failed',
}

export type OnCloseCallback = (dispatch: CoreDispatch) => void;
